import * as React from "react"

import { IOldUIContext } from "./global"

// NOTE: the default context value is only used during tests
export const OldUIContext = React.createContext({} as IOldUIContext)

export default OldUIContext
